import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';
import { updateUserAffiliationPatch } from '@/services/api/requests/organization';
import { TCustomAxiosError } from '@/services/api';
import queryKeys from '@/constants/queryKeys';
import { TUserAffiliation } from '@/types/User.types';

const useUpdateUserAffiliation = (orgId: string, onSuccessCallback?: () => void) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: async ({ userId, newAffiliation }: { userId: string; newAffiliation: TUserAffiliation }) => {
      const response = await updateUserAffiliationPatch(orgId, userId, newAffiliation);

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.organization.members] });

      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Member affiliation update successful!',
      });

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          title: `Error while updating member's affiliation`,
        },
        error,
      );
    },
  });

  return { isPending, mutate };
};

export default useUpdateUserAffiliation;
